export default function Hero() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1588286840104-8957b019727f?w=1920&q=80"
          alt="Yoga sereno na natureza"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-cream/60 via-cream/30 to-cream/80" />
        <div className="absolute inset-0 bg-gradient-to-r from-cream/50 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center max-w-4xl mx-auto px-6">
        <p className="font-dm text-xs tracking-[0.4em] text-sage uppercase mb-6 opacity-0 animate-[slideUp_0.8s_ease_0.3s_forwards]">
          Estúdio de Wellness · Lisboa
        </p>
        <h1 className="font-playfair italic text-6xl md:text-8xl font-light text-ink leading-tight mb-6 opacity-0 animate-[slideUp_0.8s_ease_0.5s_forwards]">
          Encontra o Teu<br />
          <span className="text-sage-dark">Equilíbrio</span>
        </h1>
        <p className="font-dm text-lg text-ink-light max-w-xl mx-auto mb-10 leading-relaxed opacity-0 animate-[slideUp_0.8s_ease_0.7s_forwards]">
          Um espaço de serenidade onde o corpo e a mente encontram harmonia. Yoga, meditação e terapias para o teu bem-estar.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 opacity-0 animate-[slideUp_0.8s_ease_0.9s_forwards]">
          <button
            onClick={() => scrollTo('#servicos')}
            className="font-dm text-sm bg-sage text-white px-8 py-3.5 rounded-full hover:bg-sage-dark transition-all duration-300 hover:shadow-lg hover:shadow-sage/30 cursor-pointer"
          >
            Explorar Serviços
          </button>
          <button
            onClick={() => scrollTo('#horarios')}
            className="font-dm text-sm border border-ink/20 text-ink px-8 py-3.5 rounded-full hover:border-sage hover:text-sage transition-all duration-300 cursor-pointer"
          >
            Ver Horários
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-60 animate-[fadeIn_1s_ease_1.5s_forwards] opacity-0">
        <span className="font-dm text-xs tracking-widest text-ink-light">scroll</span>
        <div className="w-px h-10 bg-sage/40 relative overflow-hidden">
          <div className="w-full h-1/2 bg-sage animate-bounce absolute top-0" />
        </div>
      </div>
    </section>
  );
}
